import { Notification } from '@/types';
import api from './client/axios';

export const getNotifications = async (): Promise<Notification[]> => {
  const response = await api.get('/notifications');
  return response.data.data!;
};

export const markNotificationAsRead = async (
  notificationId: string,
): Promise<Notification> => {
  const response = await api.patch(`/notifications/${notificationId}/read`);
  return response.data.data!;
};

export const markAllNotificationsAsRead = async (): Promise<{
  count: number;
}> => {
  const response = await api.patch('/notifications/read');
  return response.data.data!;
};
